import Cookies from 'js-cookie'

import { sha256 } from 'utils/hash'

declare global {
  interface Window {
    fbq:
      | ((
          type: string,
          name: string,
          value?: unknown,
          options?: unknown,
        ) => void)
      | undefined
  }
}

export const getFacebookFbp = () => {
  return Cookies.get('_fbp')
}

export const getFacebookFbc = () => {
  return Cookies.get('_fbc')
}

export interface UserData {
  email?: string
  [key: string]: unknown
}

export interface FacebookData {
  userData?: UserData
  eventId?: string
  [key: string]: unknown
}

export const trackFacebookEvent = async (
  eventName: string,
  {
    userData: { email, externalId, ...userData } = {},
    eventId,
    ...data
  }: FacebookData,
) => {
  if (!window.fbq) {
    console.error('The Facebook Pixel script could not be found.')
    return
  }

  let hashedEmail

  if (email) {
    hashedEmail = await sha256(email)
  }

  const eventData = {
    ...data,
    ...userData,
    ...(!!externalId && { external_id: externalId }),
    ...(!!email && { em: hashedEmail }),
    fbp: getFacebookFbp(),
    fbc: getFacebookFbc(),
  }

  window.fbq('track', eventName, eventData, { eventID: eventId })
}
